'use strict';

const angular = require('angular');

module.exports = angular.module('spinnaker.loadBalancer.configure.openstack', [
  require('./wizard/upsert.controller.js').name,
]);



// WEBPACK FOOTER //
// ./app/scripts/modules/openstack/src/loadBalancer/configure/configure.openstack.module.js